import {
  AspectRatio,
  Resolution,
} from 'src/domains/calculators/utilities/types';

/**
 * Format aspect ratio text with squeeze factor
 */
export function formatAspectRatioWithSqueezeFactor(
  aspectRatio: AspectRatio,
  squeezeFactor: number
): string {
  let str = `${formatNumber(aspectRatio[0], 2)}:${aspectRatio[1]}`;

  if (squeezeFactor === 1.0) {
    str += ' Spherical';
  } else {
    str += ` Anamorphic (${formatNumber(squeezeFactor, 2)}x)`;
  }

  return str;
}

/**
 * Format pixel numbers with 4 digit precision
 * @example "Pixel 0000" for 0, "Pixel 0123" for 123, "Pixel 1234" for 1234
 */
export function formatPixelText(value: number): string {
  return `Pixel ${value.toString().padStart(4, '0')}`;
}

/**
 * Format dimension text for display
 */
export function formatDimensionText(
  label: string,
  resolution: Resolution
): string {
  return `${label}: ${resolution.width} x ${resolution.height}`;
}

/**
 * Format numbers with appropriate precision
 */
function formatNumber(value: number, fractionDigits: number): string {
  let str = value.toFixed(fractionDigits);
  while (str.endsWith('0')) {
    str = str.substring(0, str.length - 1);
  }
  if (str.endsWith('.')) {
    str = str.substring(0, str.length - 1);
  }
  return str;
}
